import { ProcessStateType } from './../config/types/Common';
// AUTH
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';

// ROUTES
export const ADD_METADATA = 'ADD_METADATA';
export const REMOVE_METADATA = 'REMOVE_METADATA';
export const ADD_ROUTES = 'ADD_ROUTES';
export const SET_DATE = 'SET_DATE';
export const ROUTES_AVAILABLE = 'ROUTES_AVAILABLE';
export const ABORT_FETCH = 'ABORT_FETCH';
export const UPDATE_ROUTES = 'UPDATE_ROUTES';
export const GET_ROUTE_DAYS_PER_MONTH = 'GET_ROUTE_DAYS_PER_MONTH';
export const EDIT_TIMELINE = 'EDIT_TIMELINE';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_ROUTE_PAGINATION = 'SET_ROUTE_PAGINATION';
export const SET_SINGLE_TOUR_VIEW = 'SET_SINGLE_TOUR_VIEW';
export const SET_MULTI_TOUR_VIEW = 'SET_MULTI_TOUR_VIEW';
export const SET_SELECTED_ROUTES = 'SET_SELECTED_ROUTES';
export const SET_ROUTE_STRINGS = 'SET_ROUTE_STRINGS';
export const PATCH_TIMELINE = 'PATCH_TIMELINE';
export const SELECT_TIMELINEITEM = 'SELECT_TIMELINEITEM';
export const SET_TIMELINE_RANGE = 'SET_TIMELINE_RANGE';
export const EDIT_ROUTE = 'EDIT_ROUTE';
export const UPDATE_ROUTE_COLOR = 'UPDATE_ROUTE_COLOR';
export const REMOVE_ROUTE = 'REMOVE_ROUTE';
export const TOGGLE_TIMELINE_DETAILS = 'TOGGLE_TIMELINE_DETAILS';
export const SET_CACHE = 'SET_CACHE';
export const SET_TIMELINE_HIGHLIGHTS = 'SET_TIMELINE_HIGHLIGHTS';
export const GROUP_ROUTES_BY_VALUE = 'GROUP_ROUTES_BY_VALUE';
export const UPDATE_ROUTE_CACHE = 'UPDATE_ROUTE_CACHE';
export const SET_DISABLED_DATES = 'SET_DISABLED_DATES';
export const SET_ROUTE_RANGE_DATA = 'SET_ROUTE_RANGE_DATA';
export const SET_PROCESS_BY_DATE = 'SET_PROCESS_BY_DATE';
export const SET_ROUTES_BY_PROCESS = 'SET_ROUTES_BY_PROCESS';
export const SET_ROUTES_LOADING = 'SET_ROUTES_LOADING';
export const SET_DELETED_ROUTE = 'SET_DELETED_ROUTE';
export const SET_REASSIGNED_SHIPMENTS = 'SET_REASSIGNED_SHIPMENTS';
export const SET_IS_MUST_MODE_ENABLED = 'SET_IS_MUST_MODE_ENABLED';
export const SET_MUST_MODE_SHIPMENTS = 'SET_MUST_MODE_SHIPMENTS';
export const SET_IS_UPDATE_PLANNING_RUNNING = 'SET_IS_UPDATE_PLANNING_RUNNING';
export const SET_LOCKED_VEHICLES = 'SET_LOCKED_VEHICLES';
export const RESET_REASSIGNED_SHIPMENTS = 'RESET_REASSIGNED_SHIPMENTS';
export const SET_SELECTED_TOUR_VEHICLE = 'SET_SELECTED_TOUR_VEHICLE';
// DELIVERIES

export const SET_DELIVERIES = 'SET_DELIVERIES';
export const SET_PROBLEMATIC_DELIVERIES = 'SET_PROBLEMATIC_DELIVERIES';

// CONTROLLING
export const FETCH_PUNCTUAL_SUCCESS = 'FETCH_PUNCTUAL_SUCCESS';
export const FETCH_PUNCTUAL_ERROR = 'FETCH_PUNCTUAL_ERROR';
export const DISPATCH_LOG = 'DISPATCH_LOG';
export const SET_UNASSIGNED_TASKS = 'SET_UNASSIGNED_TASKS';
export const SET_PUNCTUAL_DELIVERIES = 'SET_PUNCTUAL_DELIVERIES';
export const SET_BALANCED_DELIVERIES = 'SET_BALANCED_DELIVERIES';
// STATI
export const SET_DELIVERY_STATI = 'SET_DELIVERY_STATI';

// COMMON ACTIONS
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_COMPANY = 'SET_COMPANY';
export const FETCH_START = 'FETCH_START';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const FETCH_END = 'FETCH_END';
export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';
export const SET_SELECTED_PROCESS = 'SET_SELECTED_PROCESS';
export const SET_SELECTED_VERSION = 'SET_SELECTED_VERSION';
export const SET_INSTANCE = 'SET_INSTANCE';
export const SET_WORKTIME_WINDOW = 'SET_WORKTIME_WINDOW';
export const SET_DEPOTS = 'SET_DEPOTS';
export const SET_LOAD_DIMENSION = 'SET_LOAD_DIMENSION';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const SET_USER = 'SET_USER';
export const CHANGE_EXPORT_COLS = 'CHANGE_EXPORT_COLS';
export const EDIT_DEPOT = 'EDIT_DEPOT';
export const DELETE_DEPOT = 'DELETE_DEPOT';
export const ADD_DEPOT = 'ADD_DEPOT';
export const SET_DELIVERY_STATUS_TYPES = 'SET_DELIVERY_STATUS_TYPES';
export const SET_DELIVERY_CATEGORY_TYPES = 'SET_DELIVERY_CATEGORY_TYPES';
export const TOGGLE_CORRECTION = 'TOGGLE_CORRECTION';
export const TOGGLE_LIST = 'TOGGLE_LIST';
export const SET_PROCESS_HISTORY = 'SET_PROCESS_HISTORY';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_HISTORY_FILTER = 'SET_HISTORY_FILTER';
export const SET_HISTORY_LOADING = 'SET_HISTORY_LOADING';
export const SEEN_PROCESS = 'SEEN_PROCESS';
export const SET_SUMMARY = 'SET_SUMMARY';
export const SET_LOAD_UNITS = 'SET_LOAD_UNITS';
export const SET_LOAD_UNIT_PAGINATION = 'SET_LOAD_UNIT_PAGINATION';
export const SET_USE_TERRITORIES = 'SET_USE_TERRITORIES';
export const SET_LOAD_UNIT_DRAFT = 'SET_LOAD_UNIT_DRAFT';
export const SET_SELECTED_DIMENSION = 'SET_SELECTED_DIMENSION';
export const SET_PREFILLED_process_id = 'SET_PREFILLED_process_id';
export const SET_RECENT_PLANNING_DATE = 'SET_RECENT_PLANNING_DATE';
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export const SET_CURRENT_PAGE ='SET_CURRENT_PAGE';
export const SET_TOTAL_PLANNING_COUNT = 'SET_TOTAL_PLANNING_COUNT';
export const SET_PROCESS_PAGE_CACHE ='SET_PROCESS_PAGE_CACHE';
export const SET_SHIPMENT_SETTINGS  ='SET_SHIPMENT_SETTINGS';
export const UPDATE_TIME_WINDOW = 'UPDATE_TIME_WINDOW';
export const SET_UI_FLAGS = "SET_UI_FLAGS";


export const processTypes: ProcessStateType = {
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  WAITING_FOR_INPUT: 'WAITING_FOR_INPUT',
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  GENERATED: 'GENERATED',
  RUNNING: 'RUNNING',
  RESULTS_AVAILABLE: 'RESULTS_AVAILABLE',
  COMPLETED: 'COMPLETED',
  FINISHED: 'FINISHED'
};

// JOBS
export const SAVE_STARTADDRESS = 'SAVE_STARTADDRESS';
export const SAVE_DESTINATIONADDRESS = 'SAVE_DESTINATIONADDRESS';
export const SET_VIEWOPTIONS = 'SET_VIEWOPTIONS';
export const SET_JOBLIST_FILTER = 'SET_JOBLIST_FILTER';
export const SET_FILTERED_ORDERS = 'SET_FILTERED_ORDERS';
export const SET_JOBLIST_CATEGORY_FILTER = 'SET_JOBLIST_CATEGORY_FILTER';
export const DISABLE_JOB_SELECTION = 'DISABLE_JOB_SELECTION';
export const SET_JOB_SELECTION = 'SET_JOB_SELECTION';
export const SET_MARKED_JOBS = 'SET_MARKED_JOBS';
export const SET_LIST_FOCUS = 'SET_LIST_FOCUS';
export const SET_LIST_CHUNKS = 'SET_LIST_CHUNKS';
export const SELECT_ALL_JOBS = 'SELECT_ALL_JOBS';
export const SET_FOCUSED_ROUTE = 'SET_FOCUSED_ROUTE';
export const SET_DELIVERYTYPES = 'SET_DELIVERYTYPES';
export const SET_PROBLEMDELIVERIES = 'SET_PROBLEMDELIVERIES';
export const SET_ACTIVE_LIST_TAB = 'SET_ACTIVE_LIST_TAB';
export const SET_PROCESS = 'SET_PROCESS';
export const SET_OPTIMIZATION_DATA ='SET_OPTIMIZATION_DATA';
export const REMOVE_PROCESS = 'REMOVE_PROCESS';
export const SET_JOBS_SEARCH = 'SET_JOBS_SEARCH';
export const SET_LIST_SORT = 'SET_LIST_SORT';
export const SET_ORDERS_LOADING = 'SET_ORDERS_LOADING';
export const ADD_DELIVERY = 'ADD_DELIVERY';
export const PATCH_DELIVERY = 'PATCH_DELIVERY';
export const DELIVERY_META_FORM = [
  'id',
  'contactcompany',
  'contactfirstname',
  'contactlastname',
  'additional',
  'street',
  'housenumber',
  'postalcode',
  'city',
  'customernr',
  'custom_tour',
  'deliverytype_id',
  'els',
  'status',
  'has_timewindow',
  'route_id',
  'pickup_id',
  'pickup_ref_id',
  'location'
];

// ACTIONS
export const SET_ACTIONS = 'SET_ACTIONS';
export const TOGGLE_UPLOADMODAL = 'TOGGLE_UPLOADMODAL';
export const TOGGLE_UPGRADE = 'TOGGLE_UPGRADE';

// SCENARIOS
export const SET_PLANNINGS = 'SET_PLANNINGS';
export const FOCUS_PLANNING = 'FOCUS_PLANNING';
export const SET_PLANNING = 'SET_PLANNING';
export const ADD_SCENARIOS = 'ADD_SCENARIOS';
export const FILTER_SCENARIOS = 'FILTER_SCENARIOS';
export const ADD_SCENARIO_TO_SHORTLIST = 'ADD_SCENARIO_TO_SHORTLIST';
export const SET_SIMULATIONS = 'SET_SIMULATIONS';
export const SHOW_SIMULATION_DETAIL = 'SHOW_SIMULATION_DETAIL';
export const FOCUS_SCENARIO = 'FOCUS_SCENARIO';
export const SET_SCENARIO_FILTER_PARAMS = 'SET_SCENARIO_FILTER_PARAMS';
export const SET_SCENARIO_LOADING = 'SET_SCENARIO_LOADING';
export const SET_SCENARIO_FILTER_LOADING = 'SET_SCENARIO_FILTER_LOADING';
export const ADD_FILTER_PARAM = 'ADD_FILTER_PARAM';
export const REMOVE_FILTER_PARAM = 'REMOVE_FILTER_PARAM';
export const SET_TABLE_COLUMNS = 'SET_TABLE_COLUMNS';
export const SET_TABLE_COLUMN_WIDTH = 'SET_TABLE_COLUMN_WIDTH';
export const SET_VISTED_SCENARIOS = 'SET_VISTED_SCENARIOS';
export const ADD_SIMULATION_DRAFT = 'ADD_SIMULATION_DRAFT';
export const SET_ERROR = 'SET_ERROR';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';
export const ADD_SCENARIO_TO_COMPARISON = 'ADD_SCENARIO_TO_COMPARISON';
export const REMOVE_SCENARIO_FROM_SHORTLIST = 'REMOVE_SCENARIO_FROM_SHORTLIST';
export const REMOVE_SCENARIO_FROM_COMPARISON = 'REMOVE_SCENARIO_FROM_COMPARISON';

// PLANNING
export const COMPLETED_CORRECTION = 'COMPLETED_CORRECTION';
export const IN_PLANNING = 'IN_PLANNING';
export const SET_ROUTE_COLORS = 'SET_ROUTE_COLORS';
export const SET_SELECTED_PROCESS_DELIVERIES = 'SET_SELECTED_PROCESS_DELIVERIES';
export const SET_SELECTED_PROCESS_DROPPED_DELIVERIES = 'SET_SELECTED_PROCESS_DROPPED_DELIVERIES';
export const SET_PLANNING_STATUS_CODE = 'SET_PLANNING_STATUS_CODE';

// VEHICLES
export const SET_VEHICLETYPES = 'SET_VEHICLETYPES';
export const SET_VEHICLES_DATA ='SET_VEHICLES_DATA';
export const SET_VEHICLE_LOADCLASS = 'SET_VEHICLE_LOADCLASS';

// TERRITORIES
export const SET_POTALCODES = 'SET_ZIPS';
export const SET_TERRITORIES = 'SET_TERRITORIES';
export const SET_TERRITORY_COLORS = 'SET_TERRITORY_COLORS';
export const SET_SELECTED_LOADCLASS = 'SET_SELECTED_LOADCLASS';
export const SET_POSTALCODE_REQUEST = 'SET_POSTALCODE_REQUEST';
export const SET_SELECTED_TERRITORY = 'SET_SELECTED_TERRITORY';

export const SET_TERRITORY_REQUEST = 'SET_TERRITORY_REQUEST';

// ENUMS

export const groupingTypes = {
  ROUTE: 'id',
  VEHICLE: 'vehicle_id'
};
// For Roll karte
export const SET_ACTIVE_COLS = "SET_ACTIVE_COLS"

// For Enable stop unit
export enum EnableStopUnitOption {
  OFF = 'off',
  BY_CUSTOMER_NUMBER = 'by_customer_number',
  BY_DISTANCE = 'by_distance',
}

export const enableStopUnitOptions: { value: EnableStopUnitOption; label: string }[] = [
  { value: EnableStopUnitOption.OFF, label: 'Off' },
  { value: EnableStopUnitOption.BY_CUSTOMER_NUMBER, label: 'By Customer Number' },
  { value: EnableStopUnitOption.BY_DISTANCE, label: 'By Distance' },
];